'use strict';

function isDefined(o) {
  return o !== undefined;
}

module.exports = isDefined;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/isDefined.js
// module id = 11
// module chunks = 0